import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Reserver } from "./reserver";
export function ReserverTracking() {
    return /*#__PURE__*/ _jsx(Reserver, {
        enableTracking: true
    });
}
